import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Icon } from "./SearchIcon.Parts";

export const SearchIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<"svg">
>((props, ref) => (
  <Icon
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M9.08856 17.6771C4.21474 17.6771 0.25 13.7124 0.25 8.83856C0.25 3.96474 4.21474 0 9.08856 0C13.9624 0 17.9271 3.96474 17.9271 8.83856C17.9271 13.7124 13.9624 17.6771 9.08856 17.6771ZM9.08856 2.58079C5.63804 2.58079 2.83079 5.38804 2.83079 8.83856C2.83079 12.2891 5.63804 15.0963 9.08856 15.0963C12.5391 15.0963 15.3463 12.2891 15.3463 8.83856C15.3463 5.38804 12.5391 2.58079 9.08856 2.58079Z"
      fill="currentColor"
    />
    <path
      d="M14.8284 13.2447L19.4394 17.8558C19.616 18.0323 19.616 18.3179 19.4394 18.4945L18.2533 19.6806C18.0767 19.8572 17.7911 19.8572 17.6145 19.6806L13.0035 15.0696C12.4364 14.5025 13.0791 14.2527 13.4935 13.7648C13.9171 13.266 14.3297 12.746 14.8284 13.2447Z"
      fill="currentColor"
    />
  </Icon>
));
